export function getENV(str) { return process.env['VUE_APP_' + str]; }

export function scrollTo(id) {
    const data = document.getElementById(id).getBoundingClientRect();

    window.scroll(0, data.top + window.scrollY);
}